import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowNodeCommands } from '../constant';
export var NsSelectNode;
(function (NsSelectNode) {
    NsSelectNode.command = XFlowNodeCommands.SELECT_NODE;
    NsSelectNode.hookKey = 'selectNode';
})(NsSelectNode || (NsSelectNode = {}));
let SelectNodeCommand = class SelectNodeCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.selectNode.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const currentSelectionIds = x6Graph.getSelectedCells().map(node => node.id);
                const { nodeIds, resetSelection, commandService } = handlerArgs;
                if (resetSelection) {
                    x6Graph.resetSelection(nodeIds);
                }
                else {
                    x6Graph.select(nodeIds);
                }
                this.ctx.addUndo({
                    dispose: () => {
                        commandService.executeUndoCommand(XFlowNodeCommands.SELECT_NODE.id, {
                            nodeIds: currentSelectionIds,
                            resetSelection: true,
                        });
                    },
                });
                return {};
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], SelectNodeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SelectNodeCommand.prototype, "init", null);
SelectNodeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsSelectNode.command.id },
    })
    /** 节点更新命令 */
], SelectNodeCommand);
export { SelectNodeCommand };
//# sourceMappingURL=node-select.js.map